import { render, staticRenderFns } from "./BdSetting.vue?vue&type=template&id=3c5a0523&scoped=true&"
import script from "./BdSetting.vue?vue&type=script&lang=js&"
export * from "./BdSetting.vue?vue&type=script&lang=js&"
import style0 from "./BdSetting.vue?vue&type=style&index=0&id=3c5a0523&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5a0523",
  null
  
)

export default component.exports